import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Button as MuiButton } from '@mui/material';
import { useSelector } from '@client/hooks/redux.hooks';
import { getUserActs, getUserVenues } from '@client/selectors/helpers/session';
import { ProfileTypes } from '@sda/enums';
import { Modal } from '@client/components/globals/Modal';
import { useIsMobile } from '@client/hooks/dom.hooks';
import { SwitchProfileModal } from './SwitchProfileModal';

interface ManageProfileButtonProps {
  readonly beaconId: string;
  readonly beaconProfileType: ProfileTypes;
}

export const ManageProfileButton: React.FC<ManageProfileButtonProps> = ({ beaconId, beaconProfileType }) => {
  const isMobile = useIsMobile();

  const acts = useSelector(getUserActs);
  const venues = useSelector(getUserVenues);

  const needsAct = beaconProfileType === ProfileTypes.VENUE;
  const profiles = needsAct ? acts : venues;

  const handleSwitchProfileButtonClick = useCallback(() => {
    Modal.show({
      title: needsAct ? 'Switch to Artist Profile' : 'Switch to Host Profile',
      body: <SwitchProfileModal
        profiles={profiles}
        beaconProfileType={beaconProfileType}
      />,
      buttons: [],
    });
  }, [beaconProfileType, needsAct, profiles]);

  if (profiles?.length) {
    return (
      <MuiButton
        id="sda-showcall-switch-profile-button"
        onClick={handleSwitchProfileButtonClick}
        color="primary"
        variant="contained"
        size={isMobile ? 'small' : 'medium'}
      >
        Switch Profiles
      </MuiButton>
    );
  }

  return (
    <MuiButton
      id="sda-showcall-create-profile-button"
      component={Link}
      to={`/connect/${beaconId}/${needsAct ? 'artist' : 'host'}`}
      color="primary"
      variant="contained"
      size={isMobile ? 'small' : 'medium'}
    >
      {needsAct ? 'Create Artist Profile' : 'Create Host Profile'}
    </MuiButton>
  );
};
